import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const KPKLogo = () => (
  <img src="/logo.png?v=6" alt="Ключ под ключ" style={{ width: 36, height: 36, objectFit: 'contain' }} />
);

const ICON_PATHS = {
  overview: 'M3 13h8V3H3zM13 21h8V11h-8zM3 21h8v-6H3zM13 3v6h8V3z',
  bank: 'M3 10h18M5 10v8M9.5 10v8M14.5 10v8M19 10v8M3 21h18M12 3l9 5H3z',
  store: 'M4 10v10h16V10M3 4h18l-1.5 6h-15zM9 20v-6h6v6',
  funnel: 'M3 4h18l-7 8v6l-4 2v-8z',
  handshake: 'M2 12l4-4 4 2 3-3 4 1 5 4-4 4M6 14l3 3M9 12l4 4M13 11l3 3',
  building: 'M4 21V5l8-3v19M12 8h8v13M8 7v.01M8 11v.01M8 15v.01M16 12v.01M16 16v.01M2 21h20',
  receipt: 'M5 3h14v18l-3-2-2 2-2-2-2 2-2-2-3 2zM9 8h6M9 12h6M9 16h3',
  hammer: 'M14 4l6 6-3 3-6-6zM11 7l-8 8 3 3 8-8',
  key: 'M8 15a4 4 0 1 1 0-8 4 4 0 0 1 0 8zM12 11h9M18 11v3M15 11v2',
  cart: 'M3 4h2l2.5 11h11L21 7H6.5M9 20a1 1 0 1 0 0-.01M18 20a1 1 0 1 0 0-.01',
  briefcase: 'M3 7h18v13H3zM8 7V4h8v3M3 12h18',
  bot: 'M5 8h14v11H5zM12 4v4M9 13v.01M15 13v.01M9 16h6M2 12v3M22 12v3',
  brain: 'M12 4a3 3 0 0 0-3 3 3 3 0 0 0-3 3 3 3 0 0 0 1 5 3 3 0 0 0 5 4zM12 4a3 3 0 0 1 3 3 3 3 0 0 1 3 3 3 3 0 0 1-1 5 3 3 0 0 1-5 4z',
  trend: 'M3 17l6-6 4 4 8-8M15 7h6v6',
  chart: 'M4 20V10M10 20V4M16 20v-8M22 20H2',
  ledger: 'M5 3h12a2 2 0 0 1 2 2v16H7a2 2 0 0 1-2-2zM5 17a2 2 0 0 1 2-2h12M9 7h6',
  wallet: 'M3 7h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3zM3 7l12-4v4M16 13h.01',
  sync: 'M20 11a8 8 0 0 0-14.5-4.5L4 8M4 4v4h4M4 13a8 8 0 0 0 14.5 4.5L20 16M20 20v-4h-4',
  logout: 'M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10',
};

function Icon({ name, size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
      <path d={ICON_PATHS[name]} />
    </svg>
  );
}

// roles: перечень ролей, которым доступен пункт меню
// admin — всё, manager — операционка включая зарплату, franchise — розница+франшиза,
// franchise_menu — только блок франшизы, viewer — базовый просмотр
const links = [
  { to: '/', icon: 'overview', label: 'Обзор', roles: ['admin', 'manager', 'viewer'] },
  { to: '/banks', icon: 'bank', label: 'Банки', roles: ['admin', 'manager'] },

  { to: '/retail', icon: 'store', label: 'Моя розница', roles: ['admin', 'manager', 'viewer', 'franchise', 'retail'], divider: true, sectionLabel: 'Розница' },
  { to: '/marketing', icon: 'funnel', label: 'Воронка', roles: ['admin', 'manager', 'viewer', 'franchise', 'retail'] },

  { to: '/fdm',     icon: 'handshake', label: 'ФДМ', roles: ['admin', 'manager', 'franchise', 'franchise_menu'], divider: true, sectionLabel: 'Франшиза' },
  { to: '/partner', icon: 'building', label: 'Партнёрский портал', roles: ['admin', 'manager', 'franchise', 'franchise_menu'] },
  { to: '/partner-saas', icon: 'receipt', label: 'Partner SaaS', roles: ['admin', 'manager', 'franchise', 'franchise_menu'] },
  { to: '/partner-os', icon: 'building', label: 'Кабинет партнёра', roles: ['admin', 'manager', 'franchise', 'franchise_menu'] },
  { to: '/bober',   icon: 'hammer', label: 'Бобёрмастер Россия', roles: ['admin', 'manager', 'franchise', 'franchise_menu'] },
  { to: '/kpk',     icon: 'key', label: 'КПК Россия', roles: ['admin', 'manager', 'franchise', 'franchise_menu'] },

  { to: '/procurement', icon: 'cart', label: 'Закупщик Pro', roles: ['admin', 'manager', 'buyer'], divider: true, sectionLabel: 'Аналитика' },
  { to: '/crm',      icon: 'briefcase', label: 'CRM', roles: ['admin', 'manager'] },
  { to: '/crm/ai-agent', icon: 'bot', label: 'Bitrix AI agent', roles: ['admin', 'manager', 'retail'] },
  { to: '/ai-rop', icon: 'brain', label: 'AI РОП', roles: ['admin', 'manager'] },
  { to: '/seo', icon: 'trend', label: 'SEO-аналитика', roles: ['admin', 'manager'] },
  { to: '/planfact', icon: 'chart', label: 'ДДС и P&L', roles: ['admin', 'manager'] },

  { to: '/findirector', icon: 'trend', label: 'Финдиректор', roles: ['admin', 'manager', 'buyer'], divider: true, sectionLabel: '1С' },
  { to: '/accounting', icon: 'ledger', label: 'Бухгалтерия', roles: ['admin', 'manager'] },
];

function canSee(userRole, link) {
  return (link.roles || ['admin']).includes(userRole);
}

const ROLE_LABELS = {
  admin: 'Администратор', manager: 'Менеджер',
  franchise: 'Менеджер франшизы', viewer: 'Просмотр', buyer: 'Закупщик',
  franchise_menu: 'Франшиза',
  retail: 'Руководитель розницы',
};

const SIDEBAR_VARS = {
  '--text1': '#ffffff',
  '--text2': '#9fb0b4',
  '--border': 'rgba(255,255,255,0.10)',
  '--bg3': 'rgba(255,255,255,0.06)',
};

export default function Sidebar({ onSync, syncing, user, onLogout, mobileOpen, onMobileClose }) {
  const userRole = user?.role || 'viewer';
  const visibleLinks = links.filter(l => canSee(userRole, l));

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <>
      {mobileOpen && (
        <div
          onClick={onMobileClose}
          style={{
            position: 'fixed', inset: 0,
            background: 'rgba(0,0,0,0.6)',
            zIndex: 199,
            display: 'none',
          }}
          className="mobile-overlay"
        />
      )}
    <aside style={{
      ...SIDEBAR_VARS,
      width: 230,
      height: '100vh',
      background: 'var(--brand-dark)',
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      padding: '0',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 200,
      overflowY: 'auto',
      overflowX: 'hidden',
      transition: 'transform 0.28s cubic-bezier(0.4,0,0.2,1)',
    }}
    className={mobileOpen ? 'sidebar sidebar-open' : 'sidebar'}
    >
      <div style={{ padding: '22px 20px 18px', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
          <KPKLogo />
          <div>
            <div style={{ fontSize: 15, fontWeight: 800, color: '#fff', lineHeight: 1.1, letterSpacing: '-0.01em' }}>
              Ключ под ключ
            </div>
            <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 3, fontWeight: 600 }}>
              Аналитика бизнеса
            </div>
          </div>
        </div>
      </div>

      <nav style={{ flex: 1, padding: '4px 12px 12px' }}>
        {visibleLinks.map((l, idx) => {
          const showDivider = l.divider && idx > 0;

          return (
            <React.Fragment key={l.to}>
              {showDivider && l.sectionLabel && (
                <div style={{
                  fontSize: 11, fontWeight: 600,
                  color: 'var(--text2)', padding: '16px 10px 6px', opacity: 0.75,
                }}>{l.sectionLabel}</div>
              )}
              <NavLink
                to={l.to}
                end={l.to === '/' || l.to === '/crm'}
                onClick={onMobileClose}
                style={({ isActive }) => ({
                  display: 'flex',
                  alignItems: 'center',
                  gap: 11,
                  height: 38,
                  padding: '0 10px',
                  marginBottom: 2,
                  textDecoration: 'none',
                  color: isActive ? '#fff' : '#c9d4d6',
                  background: isActive ? 'var(--brand-blue)' : 'transparent',
                  borderRadius: 10,
                  fontSize: 13.5,
                  fontWeight: isActive ? 700 : 500,
                  whiteSpace: 'nowrap',
                  transition: 'background 0.15s, color 0.15s',
                })}
              >
                <Icon name={l.icon} />
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{l.label}</span>
              </NavLink>
            </React.Fragment>
          );
        })}
      </nav>

      <div style={{
        padding: '14px 14px 16px',
        borderTop: '1px solid var(--border)',
        flexShrink: 0,
      }}>
        {user && (
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            marginBottom: 10, padding: '9px 10px 9px 12px',
            background: 'var(--bg3)', borderRadius: 10,
          }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 12.5, fontWeight: 700, color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {user.full_name || user.username}
              </div>
              <div style={{ fontSize: 11, color: 'var(--brand-blue)', marginTop: 2, fontWeight: 600 }}>
                {ROLE_LABELS[user.role] || user.role}
              </div>
            </div>
            <button
              onClick={onLogout}
              title="Выйти"
              style={{
                background: 'transparent', border: 'none', cursor: 'pointer',
                color: 'var(--text2)', padding: 6, display: 'flex',
                borderRadius: 8, transition: 'color 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.color = '#fff'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'var(--text2)'; }}
            >
              <Icon name="logout" size={17} />
            </button>
          </div>
        )}

        <button
          onClick={onSync}
          disabled={syncing}
          style={{
            width: '100%',
            height: 40,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            background: syncing ? 'var(--bg3)' : 'var(--brand-blue)',
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            cursor: syncing ? 'not-allowed' : 'pointer',
            fontSize: 13,
            fontWeight: 700,
            whiteSpace: 'nowrap',
            transition: 'background 0.2s',
          }}
        >
          <Icon name="sync" size={16} />
          {syncing ? 'Синхронизация…' : 'Синхронизировать'}
        </button>
        <div style={{ textAlign: 'center', fontSize: 11, color: 'var(--text2)', marginTop: 10 }}>
          Ключная мастерская · 2026
        </div>
      </div>
    </aside>
    </>
  );
}
